import React from "react";
import TicketEdition from "../../../components/management/ticket/ticket-edition/TicketEdition";

export default class TicketEditionRoute extends React.PureComponent<{inComing?: string | null},{}> {
  render(): React.ReactNode {
    return (
      <>
        <TicketEdition inComing={Number(this.props.inComing)}/>
      </>
    );
  }
}
